/** Singleton ref so mock-only services (tickets, demo ticks) can reach the active adapter. */
export type MockTicketCapable = {
  createTicket?: (dto: Record<string, unknown>) => Promise<{ id: string }>;
  updateTicket?: (dto: { ticketId: string; patch: Record<string, unknown> }) => Promise<unknown>;
  appendTicketMessage?: (dto: {
    ticketId: string;
    houseId: string;
    text: string;
    author?: { uid?: string; role?: string };
  }) => Promise<unknown>;
  subscribeTicketMessages?: (
    houseId: string,
    ticketId: string,
    cb: (rows: Array<Record<string, unknown>>) => void,
  ) => () => void;
};

let activeMockAdapter: MockTicketCapable | null = null;

export function registerMockAdapter(adapter: MockTicketCapable | null) {
  activeMockAdapter = adapter;
}

export function unregisterMockAdapter(adapter: MockTicketCapable | null) {
  if (activeMockAdapter === adapter) activeMockAdapter = null;
}

export function getMockAdapter(): MockTicketCapable | null {
  return activeMockAdapter;
}
